import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AiOutlineClose } from 'react-icons/ai';
import { toast } from 'react-toastify';

import { extractErrorsFromApi } from '../../../common/helpers';
import { type Merchant } from '../../../common/types';
import RenderErrorBag from '../../../components/render-error-bag';
import { useNotifyMerchantMutation } from '../merchant.api-slice';

interface IProps {
  isOpen: boolean;
  toggleNotifyModal: () => any;
  item: Merchant | null;
}

const NotifyItem: React.FC<IProps> = ({ item, isOpen, toggleNotifyModal }) => {
  const [notifyItem, { isLoading, isSuccess, isError, error, reset }] = useNotifyMerchantMutation();
  const [errorBag] = useState<string[]>([]);
  const { t } = useTranslation();

  const handleNotifyItem = (): void => {
    if (item?.id == null) {
      return;
    }
    void notifyItem(item.id);
    toggleNotifyModal();
  };

  useEffect(() => {
    if (isSuccess) {
      toast(t('merchants.notify.successMessage'));
      reset();
    }
    if (isError && error != null) {
      toast.error(extractErrorsFromApi(error).toString());
      reset();
    }
  }, [isSuccess, error]);

  return (
    <>
      {isOpen && item != null ? (
        <>
          <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden outline-none focus:outline-none">
            <div className="mx-auto my-6 w-1/2">
              <div className="flex flex-col rounded-lg border-0 bg-white shadow-lg outline-none focus:outline-none">
                <div className="flex items-start justify-between rounded-t border-b border-solid border-slate-200 p-5">
                  <h3 className="text-3xl font-semibold">{t('merchants.notify.title')}</h3>
                  <button
                    className="float-right ml-auto border-0 p-1 text-3xl font-semibold leading-none text-black outline-none focus:outline-none"
                    onClick={toggleNotifyModal}
                  >
                    <AiOutlineClose size={20} />
                  </button>
                </div>
                <div className="relative w-full flex-auto p-6">
                  {errorBag.length > 0 && <RenderErrorBag errorBag={errorBag} />}
                  {t('merchants.notify.body')}
                </div>
                <div className="mt-4 flex w-full justify-end space-x-2 rounded-b border-t border-solid border-slate-200 px-4 py-6">
                  <button className="rounded-lg bg-gray-200 px-5 py-2 text-black" onClick={toggleNotifyModal}>
                    {t('merchants.notify.cancelBtnLabel')}
                  </button>
                  <button
                    disabled={isLoading}
                    onClick={handleNotifyItem}
                    className="rounded-lg bg-greenColor px-4 py-2 text-white"
                  >
                    {t('merchants.notify.saveBtnLabel')}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
        </>
      ) : null}
    </>
  );
};

export default NotifyItem;
